<template>
  <div :class="{ 'button-group-center': center }">
    <kd-button
      type="secondary"
      v-if="showCancelButton"
      @click="handleCancel"
      :style="{ 'margin-right': showConfirmButton ? '10px': '0' }"
    >
      {{cancelText}}
    </kd-button>
    <kd-button
      v-if="showConfirmButton"
      type="primary" 
      :loading="confirmLoading"
      @click="handleConfirm"
      :danger="confirmButtonType === 'danger'"
    >
      {{confirmText}}
    </kd-button>
  </div>
</template>
<script>
export default {
  name: 'DialogFooter',
  props: {
    instance: Object,
    cancelText: {
      type: String,
      default: '确定'
    },
    confirmText: {
      type: String,
      default: '取消'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    confirmLoading: {
      type: Boolean
    },
    onConfirm: {
      type: Function
    },
    onClose: {
      type: Function
    },
    center: {
      type: Boolean
    },
    confirmButtonType: {
      type: String,
      default: 'primary'
    }
  },
  methods: {
    handleCancel() {
      this.onClose('cancel')
    },
    handleConfirm() {
      this.onConfirm()
    }
  }
}
</script>
